import { render, staticRenderFns } from "./FbHeader.vue?vue&type=template&id=2c658a28&"
import script from "./FbHeader.vue?vue&type=script&lang=js&"
export * from "./FbHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports